module.exports = __webpack_public_path__ + "static/media/p_26_0.73ef7098.png";